import React from "react";
import JarvisChat from "@/components/JarvisChat";
import SEO from "@/components/SEO";

const ORIGIN =
    typeof window !== "undefined" && window.location
        ? `${window.location.protocol}//${window.location.host}`
        : "https://movingmountainsinc.com";

export default function JarvisPage() {
    return (
        <div data-testid="jarvis-page">
            <SEO
                title="Jarvis — your insurance concierge | Moving Mountains"
                description="Talk to Jarvis, our calm AI concierge. Explore coverage in plain language; a licensed advisor reviews every case."
                ogImage={`${ORIGIN}/brand/og-default.png`}
            />
            <div className="border-b border-mm-line bg-white">
                <div className="mm-container py-10 sm:py-12">
                    <div className="max-w-3xl">
                        <div className="mm-eyebrow mb-3">Concierge</div>
                        <h1 className="mm-display text-4xl sm:text-5xl text-mm-navy">
                            Meet Jarvis.
                        </h1>
                        <p className="mt-4 text-mm-muted leading-relaxed">
                            A calm, patient AI concierge that helps you explore coverage in plain language — then hands off to a licensed advisor who actually cares. Never quotes, never guarantees, never sells your data.
                        </p>
                    </div>
                </div>
            </div>
            <JarvisChat />
        </div>
    );
}
